import { Component } from '@angular/core';
import { NbRequestPasswordComponent } from '@nebular/auth';

@Component({
  selector: 'ngx-request-pass',
  templateUrl: './request-password.component.html',
})
export class RequestPasswordComponent extends NbRequestPasswordComponent {

    
}